import { customComponentRef } from './consts';
export default function (editor, opts = {}) {
  const bm = editor.BlockManager;

  if (opts.blocks.indexOf(customComponentRef) >= 0) {
    const style = `
    <style>
    .${customComponentRef} {
      min-height: 50px;
    }
    </style>
`;
    const svgIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="32" height="50" fill="currentColor" class="bi bi-easel" viewBox="0 0 16 16">
  <path d="M8 0a.5.5 0 0 1 .473.337L9.046 2H14a1 1 0 0 1 1 1v7a1 1 0 0 1-1 1h-1.85l1.323 3.837a.5.5 0 1 1-.946.326L11.092 11H8.5v3a.5.5 0 0 1-1 0v-3H4.908l-1.435 4.163a.5.5 0 1 1-.946-.326L3.85 11H2a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1h4.954L7.527.337A.5.5 0 0 1 8 0zM2 3v7h12V3H2z"/>
</svg>`;
    bm.add(customComponentRef, {
      label: `
      <?xml version="1.0" encoding="utf-8"?>
      ${svgIcon}
      <div>${opts.labelCustomComponent}</div>`,
      content: `<div class="${customComponentRef}" data-gjs-type="${customComponentRef}"></div>${style}`,
      category: opts.labelCustomComponentCategory,
      render: ({ model, className }) => `
      <div class="${className}-label ${className}__drapcode-wrap">
      ${model.get('label')}
      </div>

      <span class="${className}__info no-doc">
        <a target="_blank" href="#" draggable="false">
          <i class="${className}__info-fa fa fa-info-circle" style="margin-left: 5px" title="Check how to use ${
        opts.labelCustomComponent
      }?"></i>
        </a>
      </span>
    `,
    });

    bm.add(customComponentRef + 'frequently_used', {
      label: `
      <?xml version="1.0" encoding="utf-8"?>
      ${svgIcon}
      <div>${opts.labelCustomComponent}</div>`,
      content: `<div class="${customComponentRef}" data-gjs-type="${customComponentRef}"></div>${style}`,
      category: 'Frequently Used',
      attributes: {
        style: 'order: 11',
      },
      render: ({ model, className }) => `
      <div class="${className}-label ${className}__drapcode-wrap">
      ${model.get('label')}
      </div>

      <span class="${className}__info no-doc">
        <a target="_blank" href="#" draggable="false">
          <i class="${className}__info-fa fa fa-info-circle" style="margin-left: 5px" title="Check how to use ${
        opts.labelCustomComponent
      }?"></i>
        </a>
      </span>
    `,
    });
  }
}
